import http from '../httpService';

const pjeIntegrationService = {
  getPjeIntegrationService: params => http.get('pje-integration', { params }),

  getJurisdictionOptionsService: params => http.get('pje-integration/jurisdictions', { params }),

  getPjeClassOptionsService: params => http.get(`pje-integration/classes`, { params }),

  getPjeSecretOptionsService: params => http.get(`pje-integration/secret-types`, { params }),

  getPjeSubjectOptionsService: params => http.get(`pje-integration/subjects`, { params }),

  getPjeProvinceOptions: params => http.get(`pje-integration/province`, { params }),

  getPreRegisteredDocumentsService: inquiryInvestigatedId =>
    http.get(`pje-integration/pre-register/docs/${inquiryInvestigatedId}`),

  getPjeManifestationDocuments: taskId =>
    http.get(`pje-integration/manifestation/docs/${taskId}`),

  signDocumentsService: params => http.post('pje-integration/sign', params),

  sendIntegrationService: (id, params) => http.post(`pje-integration/send-integration/${id}`, params),

  createpjeIntegration: params => http.post('pje-integration/pre-register', params),

  createPjeIntegrationFromPending: params => http.post('pje-integration/pre-register/pending', params),

  integrationService: pjeManifestationId => http.post(`pje-integration/manifestate/${pjeManifestationId}/retry`),

  cancelFileProcessService: id => http.post(`pje-integration/cancel-file-process/${id}`),

  retryProcessing: pjeFileProcessId => http.post(`pje-integration/process-file/${pjeFileProcessId}/retry`),

  getAttachmentsFromInquiryService: inquiryId => http.get(`pje-integration/attachments/${inquiryId}`),

  movementTaskStartService: inquiryId => http.post(`pje-integration/${inquiryId}/movement-tasks/start`),

  addSuperCertificateService: inquiryInvestigatedId => http.post(`pje-integration/${inquiryInvestigatedId}/super-certificate`),
};

export default pjeIntegrationService;
